module.exports = __webpack_public_path__ + "img/UTANTE-6.c04b6f67.jpg";